import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ProjectService } from '../../../services/project.service';
import { StorageService } from '../../../../Common/services/storage.service';
import { GinfoProjectDetailsVm, ProjectGeneralInfoVm } from '../../../models/project-vm';
import { ProjectConstants } from '../../../constants/component-messages';
import { Console } from 'console';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';

@Component({
  selector: 'app-ginfo-project-details',
  templateUrl: './ginfo-project-details.component.html',
  styleUrl: './ginfo-project-details.component.css'
})
export class GinfoProjectDetailsComponent {
  sreUsers: any = [];
  @Input() selectedGenInfoProject! : GinfoProjectDetailsVm;
  @Input() enablePWR: boolean = false;  
  @Input() disableAfterReview: boolean = false;
  @Input() disableAll: boolean = false;
  @Output() emitAnyValueChanged =new EventEmitter<boolean>();

  constructor(private storageService: StorageService,
    private projectService: ProjectService,private unsavedChangesService: UnsavedChangesService) {
  }
  onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }


 ngOnInit(){
    let vendorDetails = this.storageService.getItem<any>("selectedVendor");
    if(vendorDetails.vendorID > 0)
    {
      this.projectService.getSREUsers(vendorDetails.vendorID).subscribe(data => {
        this.sreUsers = [];
        this.sreUsers = data;
      },
        (error: any) => {
          console.error("SRE Error", error);
        }
      );
    }
  }


  onSpocChange(event: any) 
  {
    this.selectedGenInfoProject.sreSpoc = event.target.value;
  }

  validateFields(): string[]
  {
    let validationMessages: string[] = []
    if(this.selectedGenInfoProject.projectTitle.length == 0)
    {
      validationMessages.push(ProjectConstants.GENERALINFO_KEY_PROJECT_TITLE_REQUIRED);
    }
    // Arnab asked to comment out at this moment SRE Spoc is not mandatory 
    
    // if(this.selectedGenInfoProject.sreSpoc <= 0)
    // {
    //   validationMessages.push(ProjectConstants.GENERALINFO_KEY_SRE_SPOC__REQUIRED);
    // }

    // if(this.selectedGenInfoProject.summary != null
    //   && this.selectedGenInfoProject.summary != ""
    //   && this.selectedGenInfoProject.summary.length > 2000
    // )
    // {
    //   validationMessages.push("Summary should not be exceeded more than 1000");
    // }

    return validationMessages;
  }
}
